<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card class="information" header="data">
          <div slot="header">
            <h5 style="display: inline" class="card-title mb-0">
              Add New Issue
            </h5>
          </div>
          <div style="">
            <b-row>
              <b-col lg="6">
                <span style="color: lightgray; padding: 3px"
                  >Select Location</span
                >
                <b-form-select
                  v-model="location"
                  :options="options"
                  style="height: 45px"
                  class="mb-2 selectlocation"
                  value-field="id"
                  text-field="locaton"
                >
                </b-form-select>
              </b-col>
              <b-col lg="6">
                <span style="color: lightgray; padding: 3px"
                  >Select Urgency</span
                >
                <b-form-select
                  v-model="urgency"
                  :options="urgencyOptions"
                  style="height: 45px"
                  class="mb-2 selectlocation"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-col>
              <b-col lg="12">
                <b-form-textarea
                  id="textarea"
                  v-model="issue"
                  placeholder="Issue"
                  rows="3"
                  max-rows="6"
                ></b-form-textarea>
              </b-col>
              <b-col lg="12">
                <b-button
                  variant="outline-primary"
                  @click="sendData"
                  style="
                    display: block;
                    margin: auto;
                    margin-top: 30px;
                    height: 40px;
                    width: 130px;
                  "
                  >Submit</b-button
                >
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>

      <b-col lg="12">
        <b-card class="information" header="data">
          <div slot="header">
            <b-row>
              <b-col lg="8">
                <h5 style="display: inline" class="card-title mb-0">
                  Issues List
                </h5>
              </b-col>
              <b-col lg="4">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
          </div>
          <div style="">
            <b-table :filter="filter" :fields="fields" size="lg" :items="items">
              <template v-slot:cell(solved)="{ value }">
                {{ value ? value : "Not Solved" }}
              </template>
              <template v-slot:cell(urgency)="{ value }">
                <b-badge
                  :style="'background:' + value + ';display:block;marign:auto;'"
                  >&nbsp;&nbsp;</b-badge
                >
              </template>
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "model",
  components: {},
  data: function () {
    return {
      loadingData: true,
      filter: null,
      location: "1619",
      issue: "",
      urgency: "red",
      urgencyOptions: [
        {
          value: "red",
          text: "High",
        },
        {
          value: "orange",
          text: "Medium",
        },
        {
          value: "yellow",
          text: "Low",
        },
      ],
      options: [],
      items: [],
      fields: [
        { key: "date", label: "Date" },
        { key: "user", label: "User" },
        { key: "city", label: "Location" },
        { key: "issue", label: "Issue" },
        { key: "solved", label: "Solved" },
        { key: "urgency", label: "Urgency" },
      ],
    };
  },
  methods: {
    sendData() {
      let formData = new FormData();
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;

      formData.append("date", dateTime);
      formData.append("location", this.location);
      formData.append("issue", this.issue);
      formData.append("urgency", this.urgency);
      formData.append("user", localStorage.getItem(`${this.$company}_user`));

      this.$http
        .post("api/" + this.$company + "/issues/addIssue.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(
          (res) => {
            console.log(res.data);
            this.fetchData();
          },
          (err) => {
            console.log(err);
          }
        );
    },
    fetchLocations() {
      this.loadingData = true;
      this.$http
        .get("api/" + this.$company + "/profile/alphaLocations.php", {})
        .then(
          (res) => {
            this.options = res.data.records;
            console.log(res);
          },
          (err) => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        user: localStorage.getItem(`${this.$company}_user`),
      };
      this.$http
        .get("api/" + this.$company + "/issues/issuePreview.php", {
          params,
        })
        .then(
          (res) => {
            this.items = res.data;
            console.log(res);
          },
          (err) => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
  },
  mounted() {
    this.fetchLocations();
    this.fetchData();
  },
};
</script>

<style>
.selectlocation {
  background: #515b65;
  border: 1px solid black;
  color: white;
}
.title-details {
  padding: 0.5em;
  padding-bottom: 0.2em !important;
  font-size: 1.1em;
  display: block;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
